import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import { DialogIdentifiers, openDialogWithPayload } from '@shared/store/dialog.duck';
import { selectEditCompanyState } from '../../edit-company-page/editCompany.duck';

interface Props {
  editable: boolean;
}

export function DangerZonePanel(props: Props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const state = useSelector(selectEditCompanyState);

  const openDeleteDialog = () =>
    dispatch(openDialogWithPayload({
      activeDialog: DialogIdentifiers.DeleteCompanyDialog,
      payload: {company: {name: state.companyName}},
    }));

  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.danger-zone')}</HeadlineSmall>
      <IconButton className="editCompanyPage__deleteCompanyBtn"
                  disabled={!props.editable}
                  icon={IconTypes.Bin}
                  text="button.delete-account"
                  color="darkGrey"
                  onClick={openDeleteDialog} />
    </>
  );
}
